import Grid from "@mui/material/Grid";
import { GroupIcon } from "./GroupIcon";
import { Lock, LockOpen } from "@mui/icons-material";
import { strLang } from "../../functions/strLang";
import { svgIcons } from "../../data/svgIcons";
import { GridItem } from "../../components/GridItem";

export default function GridScreen({
  btns,
  iconList,
  handleLock,
  avatarsList,
  setOpenModal,
  dragId,
}) {
  let filteredList = iconList.filter((o) => o.id && o.users > 0);
  let emptyId = iconList.findIndex((e) => e.id && e.users === 0);
  return (
    <div
      style={{
        flex: btns ? 0 : 1,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        onScroll={() => {
          dragId = false;
        }}
        style={{
          position: "relative",
          flex: 1,
          overflow: "auto",
          backgroundColor: "white",
        }}
      >
        <Grid
          container
          spacing={5}
          padding={2}
          columns={{ xs: 2, sm: 8, md: 20 }}
        >
          {filteredList.map((o, index) => (
            <Grid id={o.id} item xs={1} sm={4} md={4} key={index}>
              <GridItem
                id={o.id}
                style={{
                  textAlign: "left",
                  position: "relative",
                  cursor: "pointer",
                  height: "100%",
                }}
              >
                <div
                  id={o.id}
                  onClick={() => {
                    setOpenModal({ status: true, group: o.id });
                  }}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <GroupIcon
                    id={o.id}
                    fill={svgIcons[o.id].color}
                    style={{
                      height: 30,
                      width: 40,
                    }}
                  />
                </div>

                {o.lock ? (
                  <Lock
                    onClick={() => {
                      handleLock(o.id, o.lock);
                    }}
                    style={{
                      position: "absolute",
                      fontSize: 30,
                      padding: 10,
                      right: 0,
                      top: 0,
                    }}
                  />
                ) : (
                  <LockOpen
                    onClick={() => {
                      handleLock(o.id, o.lock);
                    }}
                    style={{
                      position: "absolute",
                      fontSize: 30,
                      padding: 10,
                      right: 0,
                      top: 0,
                    }}
                  />
                )}

                {avatarsList(o.id, o.lock)}
                {/* {!o.lock && (
                  <div
                    id={o.id}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      fontSize: 20,
                      alignItems: "center",
                      marginRight: 10,
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => {
                      setOpenModal({ status: true, group: o.id });
                    }}
                  >
                    <GroupIcon
                      id={o.id}
                      type="plus"
                      fill={"gray"}
                      style={{
                        height: 30,
                        width: 40,
                      }}
                    />
                    {strLang("add")}
                  </div>
                )} */}
              </GridItem>
            </Grid>
          ))}
          {emptyId > -1 && (
            <Grid item xs={1} sm={4} md={4}>
              <GridItem
                style={{
                  textAlign: "left",
                  position: "relative",
                  cursor: "pointer",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    fontSize: 20,
                    alignItems: "center",
                    marginRight: 10,
                    whiteSpace: "nowrap",
                    justifyContent: "center",
                    alignContent: "center",
                    height: "100%",
                  }}
                >
                  <GroupIcon
                    id={iconList[emptyId].id}
                    type="plus"
                    fill={"gray"}
                    style={{
                      height: 30,
                      width: 40,
                    }}
                  />
                  {strLang("add")}
                  <div
                    onClick={() => {
                      setOpenModal({
                        status: true,
                        group: iconList[emptyId].id,
                      });
                    }}
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                    }}
                  ></div>
                </div>
              </GridItem>
            </Grid>
          )}
        </Grid>
        <div style={{ height: 15 }}></div>
      </div>
    </div>
  );
}
